<script setup lang="ts">
import type { LinkBlockSchema } from 'types/storyblok/link-block'
import { backgroundStyling, textColorStyling } from 'lib/storyblok'
import StoryblokNavItem from '~/storyblok/NavItem.vue'
import type { NavItemSchema } from '~/types/storyblok/nav-item'

interface Props {
  story: LinkBlockSchema
  position?: number
}

const props = withDefaults(defineProps<Props>(), {
  position: -1,
})

const background = computed(() => backgroundStyling(props.story))
const underline = computed(() => (props.story.text_underline ? 'm-underline' : ''))
const bold = computed(() => (props.story.bold ? 'm-bold' : ''))
const textColor = computed(() => textColorStyling(props.story))

const textAlign = computed(() =>
  props.story.text_align ? { 'text-align': props.story.text_align as any } : '',
)
</script>

<template>
  <div v-editable="story" class="e-linkBlock" :style="[background, textAlign, textColor]">
    <StoryblokNavItem :story="(story.url as NavItemSchema)" :class="[underline, bold]">
      <button v-if="story.is_button" class="e-btnSimple" :style="textColor">
        <span>{{ story.headline }}</span>
      </button>
      <span v-else>
        {{ story.headline }}
      </span>
    </StoryblokNavItem>
  </div>
</template>

<style lang="scss" scoped>
.e-linkBlock {
  text-align: center;
  a {
    &.m-underline {
      text-decoration: underline;
    }
    &.m-bold {
      font-weight: bold;
    }
  }
}
</style>
